// extracted by mini-css-extract-plugin
module.exports = {"root":"AuctionEndPopup_root__Ww2HK","block":"AuctionEndPopup_block__2Q0rI","blueBlock":"AuctionEndPopup_blueBlock__14y4Q","greenBlock":"AuctionEndPopup_greenBlock__3NMAk"};